export const RESUME_DOB_SESSION_KEY = 'rnlic_resumeDob';

export const getResumeDobStorageKey = (applicationNumber) =>
  `${RESUME_DOB_SESSION_KEY}:${String(applicationNumber || '').trim()}`;

export const resolveLeadDob = (data) => {
  const source = data && typeof data === "object" ? data : {};
  const candidates = [
    source.dateOfBirth,
    source.dob,
    source.liDob,
    source.lifeAssuredDob,
    source.panDateOfBirth,
    source.proposerDob,
  ];
  const matched = candidates.find(
    (value) => typeof value === 'string' && value.trim() !== '',
  );
  return matched ? matched.trim() : null;
};

export const readOwnershipDobFromSession = (effectiveAppNumber = null) => {
  try {
    const scopedDob = effectiveAppNumber
      ? sessionStorage.getItem(getResumeDobStorageKey(effectiveAppNumber))
      : null;
    const globalDob = sessionStorage.getItem(RESUME_DOB_SESSION_KEY);
    const resolved = scopedDob || globalDob || null;
    return typeof resolved === 'string' && resolved.trim() ? resolved.trim() : null;
  } catch {
    return null;
  }
};

export const syncOwnershipDobInSession = (dob, effectiveAppNumber = null) => {
  if (!dob || typeof dob !== 'string' || !dob.trim()) return;
  const normalized = dob.trim();
  try {
    if (effectiveAppNumber) {
      sessionStorage.setItem(getResumeDobStorageKey(effectiveAppNumber), normalized);
    }
    sessionStorage.setItem(RESUME_DOB_SESSION_KEY, normalized);
  } catch {
    // ignore session storage write issues
  }
};

/**
 * When DOB changes on an existing journey, send dobUpdate + oldDateOfBirth so the backend
 * can authenticate with the prior DOB and persist the new value.
 */
export const addDobUpdateMetaIfRequired = (
  payload = {},
  latestFormData = {},
  effectiveAppNumber = null,
) => {
  const latestDob = resolveLeadDob(latestFormData);
  const ownershipDob = readOwnershipDobFromSession(effectiveAppNumber);
  if (latestDob) {
    payload.dateOfBirth = latestDob;
  } else if (ownershipDob) {
    payload.dateOfBirth = ownershipDob;
  }
  if (latestDob && ownershipDob && latestDob !== ownershipDob) {
    payload.dobUpdate = true;
    payload.oldDateOfBirth = ownershipDob;
    payload.newDateOfBirth = latestDob;
  }
  return latestDob || ownershipDob || null;
};

export const addOwnershipDobProof = (
  payload = {},
  latestFormData = {},
  effectiveAppNumber = null,
) => {
  const latestDob = resolveLeadDob(latestFormData);
  const ownershipDob = readOwnershipDobFromSession(effectiveAppNumber) || latestDob;
  if (ownershipDob) {
    payload.ownershipDateOfBirth = ownershipDob;
  }
  return ownershipDob || null;
};
